<app-nav-menu></app-nav-menu>

<div class="pnr-popup">

  <!-- Search Card -->
  <div class="search-card">

    <!--<div class="row align-items-end">-->
    <!-- PNR -->
    <!--<div class="col-lg-3 col-md-4 col-sm-12 mb-3">
    <label class="pnr-search">
      PNR <span class="asteric">*</span>
    </label>

    <input type="text"
      class="form-control"
      placeholder="Enter PNR"
      [(ngModel)]="importPNR.pnr">
    </div>-->
    <!-- PCC -->
    <!--<div class="col-lg-4 col-md-5 col-sm-12 mb-3">
    <label class="pnr-search">
      PCC <span class="asteric">*</span>
    </label>

    <ng-select [items]="pccList"
      bindLabel="officeId"
      bindValue="officeId"
      [(ngModel)]="importPNR.bookingPccCode">
    </ng-select>
  </div>
  <div class="inner_body my-2" *ngIf="agencyID === 'AG01'">
    <div class="cms_card-heading">Select Company</div>
    <div class="row justify-content-center">
      <div class="form-group">
        <p-select id="fromrtcc"
          name="fromrt"
          placeholder="Select Company"
          [options]="GetAllUserBackCompanyCustomerCode"
          optionLabel="companyName"
          optionValue="userId"
          [filter]="true"
          filterBy="companyName"
          required [(ngModel)]="selectedBackCompanyUserId" #fromrt="ngModel">
        </p-select>
        <div *ngIf="fromrt.invalid && fromrt.touched" style="color:red">
          Company is required
        </div>
      </div>
    </div>
  </div>-->
  <!-- Button -->
  <!--<div class="col-lg-2 col-md-3 col-sm-12 mb-3">
  <button class="btn pnr-btn btn-block"
    (click)="importButton()">
    Import
  </button>
</div>

</div>-->
<div class="row align-items-end">

  <!-- PNR -->
  <div class="col-lg-3 col-md-4 col-sm-12 mb-3">
    <label class="pnr-search">
      PNR <span class="asteric">*</span>
    </label>

    <input type="text"
      class="form-control"
      placeholder="Enter PNR"
      [(ngModel)]="importPNR.pnr">
    </div>

    <!-- PCC -->
    <div class="col-lg-3 col-md-4 col-sm-12 mb-3">
      <label class="pnr-search">
        PCC <span class="asteric">*</span>
      </label>

      <ng-select [items]="pccList"
        bindLabel="officeId"
        bindValue="officeId"
        [(ngModel)]="importPNR.bookingPccCode">
      </ng-select>
    </div>

    <!-- Company -->
    @if (agencyID === 'AG01') {
      <div class="col-lg-3 col-md-4 col-sm-12 mb-3">
        <label class="pnr-search">
          Select Company
        </label>
        <p-select placeholder="Select Company"
          [options]="GetAllUserBackCompanyCustomerCode"
          optionLabel="companyName"
          [filter]="true"
          filterBy="companyName"
          [(ngModel)]="selectedCompany">
        </p-select>
      </div>
    }

    <!-- Import Button -->
    <div class="col-lg-3 col-md-12 col-sm-12 mb-3 text-right">
      <button class="btn pnr-btn import-btn"
        (click)="importButton()">
        Import
      </button>
    </div>

  </div>
</div>

<!-- Loader -->
<div class="loaders" id="loaderissue">
  <img src="assets/img/IMPORTPNRLOADER.svg" class="loader-img">
</div>
<!-- Error Message -->
@if (errorMessage) {
  <div class="error-message" id="error-message">
    <i class="fa fa-exclamation-circle mr-2"></i>
    {{ errorMessage }}
  </div>
}
<!-- Message -->
<div class="import-message">
  <span id="importpnridmessage"></span>
</div>

<!-- Instructions -->
<div class="instruction-card">

  <div class="content_sub">
    <i class="uil uil-circle"></i>
    <span>Create a PNR in your own PCC and queue it to us.</span>
  </div>

  <div class="content_sub">
    <i class="uil uil-circle"></i>
    <span>Retrieve the queued PNR and proceed with ticket issuance.</span>
  </div>

  <div class="content_sub">
    <i class="uil uil-circle"></i>
    <span>Please verify the fare before sending the booking to the queue.</span>
  </div>

</div>

<!-- Table -->
<table class="table table-bordered pnr-table">

  <thead>

    <tr>
      <th colspan="3" class="table-title">
        Galileo Queue Information
      </th>
    </tr>

    <tr>
      <th>PCC</th>
      <th>Airline</th>
      <th>Entry</th>
    </tr>

  </thead>

  <!--<tbody>

  <tr *ngFor="let item of importPnrEntryList$">
    <td>{{item.pcc}}</td>
    <td>{{item.airline}}</td>
    <td>{{item.entry}}</td>
  </tr>

  <tr *ngIf="importPnrEntryList$.length == 0">
    <td colspan="3" class="text-center">
      No queue entries found.
    </td>
  </tr>

</tbody>-->

</table>

</div>
